import { AUTH_API, handleApiError } from '../../utils/axios';

export const uploadImage = async (image) => {
  try {
    const response = await AUTH_API.post(`/storage/images`, image, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    const data = response.data.url;
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
